<template>
    <div id="results-buttons">
        <CancelButton router-link="/start" />
        <b-button @click="$emit('create-pdf')">
            <font-awesome-icon :icon="['fas', 'print']" />
            PDF exportieren
        </b-button>
        <b-button to="/zulassungskriterien">
            <font-awesome-icon :icon="['fas', 'vote-yea']" />
            Zulassungskriterien überprüfen
        </b-button>
        <b-button class="zhaw-primary-button" to="/kontakt" variant="primary">
            <font-awesome-icon :icon="['fas', 'envelope']" />
            Kontakt aufnehmen
        </b-button>
    </div>
</template>

<script>
    import CancelButton from "../helper-components/CancelButton";

    export default {
        name: "ResultsButtons",
        components: {CancelButton},
    }
</script>

<style scoped>

</style>